		<div class="card">
			<div class="card-header">
				Refund Policy...
			</div>
			<div class="card-body">
				<p>We do not offer refunds.</p>
			</div>
		</div>
